import React from 'react'

const ManagementFloatRequest = () => {
  return (
    <div>ManagementFloatRequest</div>
  )
}

export default ManagementFloatRequest